
const digest = 'e69e0c109c0e1f946aabbab02d5b90cfcd2d3f1a51a9e8f47d2041dfcafd86bd';
const classes = {"wrapper":"_wrapper_1mkai_1","filter":"_filter_1mkai_10","filterWrapper":"_filterWrapper_1mkai_14","chartsWrapper":"_chartsWrapper_1mkai_19","filterItemTitle":"_filterItemTitle_1mkai_49"};
const css = `._wrapper_1mkai_1 {
  font-family: Rubik, "sans-serif";
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
}
._wrapper_1mkai_1 ._filter_1mkai_10 {
  height: 100%;
  overflow-y: scroll;
}
._wrapper_1mkai_1 ._filterWrapper_1mkai_14 {
  position: relative;
  height: 100%;
  overflow-y: scroll;
}
._wrapper_1mkai_1 ._chartsWrapper_1mkai_19 {
  overflow-y: scroll;
  position: absolute;
  height: calc(100vh - 250px);
  right: 0;
  width: 100%;
  padding-right: 24px;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_1mkai_1 ._chartsWrapper_1mkai_19::-webkit-scrollbar {
  display: block;
}
._wrapper_1mkai_1 ._chartsWrapper_1mkai_19::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1mkai_1 ._chartsWrapper_1mkai_19::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1mkai_1 ._chartsWrapper_1mkai_19::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1mkai_1 ._chartsWrapper_1mkai_19::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}

._filterItemTitle_1mkai_49 {
  font-size: 14px;
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  